import { define } from '../../define.js';
import { Dialog } from './dialog.js';
export * from './dialog.js';
define('dialog', Dialog);
